import { render, staticRenderFns } from "./ViewSetsItemsModal.vue?vue&type=template&id=85aa25ea&"
import script from "./ViewSetsItemsModal.vue?vue&type=script&lang=js&"
export * from "./ViewSetsItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewSetsItemsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports